import React, { ReactNode } from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SectionStyled, SectionTitleStyled } from './styles';

interface AttributesSectionProps extends ICustomizableElement {
  title: string;
  children: ReactNode;
}

const AttributesSection: React.FC<AttributesSectionProps> = ({ title, children, className }) => (
  <SectionStyled className={className}>
    <SectionTitleStyled>{title}</SectionTitleStyled>
    {children}
  </SectionStyled>
);

export default AttributesSection;
